import React from 'react';
import WatchReview from '../watchReview'


function Oculus(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/dlhblnTnEEY" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss WWE and Blumhouse film...OCULUS. One of V's highest rated horror films (still not a 3). We spent a lot of time talking about wrestling somehow..."
            />
        )
    }   

export default Oculus;
